function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "A5A74494-13BB-486C-B0A6-5502F1776C43");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "In-App-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "SignlesOnlyPricing",
  transform: "translate(-1073.000000, -822.000000)",
  fill: "#FF5A5A"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(760.000000, 286.000000)"
}, React.createElement("g", {
  id: "Group-13-Copy",
  transform: "translate(33.000000, 291.000000)"
}, React.createElement("polygon", {
  id: "\uE88F",
  points: "293.984 247.032 288.416 252.6 293.984 258.168 292.568 259.584 287 254.016 281.432 259.584 280.016 258.168 285.584 252.6 280.016 247.032 281.432 245.616 287 251.184 292.568 245.616"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/red-x.1be46882.svg";
export { SvgComponent as ReactComponent };